<page-title [title]="titles[0]"></page-title>
<p class="description">Mantenha seus dados atualizados.</p>


<page-alert *ngIf="alerts.length > 0 && showWarningMessage" [message]="messageWarning">
</page-alert>

<mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Perfil">
    <div class="formProfile">
      <page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
      <page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>

      <form [formGroup]="formProfilePatient">
        <div class="row">
          <div class="col-xs-12 col-md-3">
            <div class="photo-upload text-center">
              <div *ngIf="profilePictureUrl" class="preview">
                <img [src]="profilePictureUrl" alt="Foto de perfil" class="profile-picture-preview" />
              </div>
              <button mat-raised-button color="primary" (click)="fileInput.click()">Escolher Foto</button>
              <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" style="display: none" />

              <mat-error *ngIf="formProfilePatient.get('photo')?.hasError('maxFileSize') ">
                O arquivo deve ter um tamanho menor que 4mb
              </mat-error>

              <mat-error *ngIf="formProfilePatient.get('photo')?.hasError('invalidFileType') ">
                Permitido apenas imagems em png e jpeg
              </mat-error>
            </div>
          </div>
          <div class="col-xs-12 col-md-9">
            <div class="row">
              <div class="col-xs-12 col-md-7">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Nome</mat-label>
                  <input type="text" matInput formControlName="name" placeholder="Nome" required
                    (keypress)="allowOnlyLetters($event)" (paste)="onPasteName($event)" />
                  <mat-error *ngIf="formProfilePatient.get('name')?.hasError('required')"> Campo obrigatório
                  </mat-error>
                  <mat-error *ngIf="formProfilePatient.get('name')?.hasError('pattern')"> O nome deve conter apenas
                    letras </mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-5">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>E-mail</mat-label>
                  <input type="text" matInput formControlName="email" placeholder="Email" readonly />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-3">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>CPF</mat-label>
                  <input type="text" matInput formControlName="cpf" placeholder="CPF" mask="000.000.000-00" required />
                  <mat-error *ngIf="formProfilePatient.get('cpf')?.hasError('required')"> Campo obrigatório </mat-error>
                  <mat-error *ngIf="formProfilePatient.get('cpf')?.hasError('pattern')"> O CPF deve conter apenas
                    números </mat-error>
                  <mat-error *ngIf="formProfilePatient.get('cpf')?.hasError('cpfInvalid')">Informe um CPF
                    válido.</mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-3">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Celular</mat-label>
                  <input matInput type="text" formControlName="mobile" mask="(00) 00000-0000" prefix="+55 "
                    [dropSpecialCharacters]="true" placeholder="(11) 91234-5678" required
                    (paste)="onPasteName($event)" />
                  <mat-error *ngIf="formProfilePatient.get('mobile')?.hasError('required')"> Campo obrigatório
                  </mat-error>
                  <mat-error *ngIf="formProfilePatient.get('mobile')?.hasError('pattern')">
                    O número de celular deve conter apenas números
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-3">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Data de nascimento</mat-label>
                  <input type="text" matInput formControlName="birthDate" placeholder="DD/MM/AAAA" mask="00/00/0000"
                    required (paste)="onPasteName($event)" />
                  <mat-error *ngIf="formProfilePatient.get('birthDate')?.hasError('required')"> Campo obrigatório
                  </mat-error>
                  <mat-error *ngIf="formProfilePatient.get('birthDate')?.hasError('pattern')">
                    A data de nascimento deve conter apenas números
                  </mat-error>
                  <mat-error *ngIf="formProfilePatient.get('birthDate')?.hasError('underAge')">
                    É preciso ser maior de Idade
                  </mat-error>
                  <mat-error *ngIf="formProfilePatient.get('birthDate')?.hasError('overAge')">
                    Entre com uma idade realista (Idade não pode exceder 120 anos).
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-3">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Gênero</mat-label>
                  <mat-select formControlName="gender" required>
                    <mat-option *ngFor="let item of genders" [value]="item.id">
                      {{ item.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="formProfilePatient.get('gender')?.hasError('required')"> Campo obrigatório
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="actions text-right">
        <button mat-flat-button color="primary" *ngIf="mode === 'UPDATE'" (click)="onSave()"
          [disabled]="formProfilePatient.invalid || isSaving">
          <ng-container *ngIf="!isSaving">Salvar</ng-container>
          <ng-container *ngIf="isSaving">
            <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
          </ng-container>
        </button>

        <button mat-flat-button color="primary" *ngIf="mode === 'CREATE'" (click)="onSave()"
          [disabled]="formProfilePatient.invalid || isSaving">
          <ng-container *ngIf="!isSaving">Criar Conta</ng-container>
          <ng-container *ngIf="isSaving">
            <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
          </ng-container>
        </button>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Endereço">
    <page-title [title]="titles[1]"></page-title>

    <ng-template matTabContent>
      <page-patient-map mode="UPDATE" (onUpdatePatient)="setPatient($event)" [patient]="patient"
        [address]="patient.address"></page-patient-map>
    </ng-template>
  </mat-tab>
</mat-tab-group>